// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1vtOh","subheader":"ReorderModal_subheader__3-rOg","listWrap":"ReorderModal_listWrap__fYtOo"};